export const locations = [
  {
    locationName: 'イオンスタイル京都桂川',
    postalCode: '601-8211',
    address: '京都府京都市久世高田町376番１',
    tel: '075-925-3120',
    googleMapUrl: 'https://maps.app.goo.gl/dj22mv5YpM6sDvpA9',
    lat: 34.96376066826339,
    lng: 135.70913357408267
  },
  {
    locationName: 'イオンスタイル亀岡',
    postalCode: '621-0815',
    address: '京都府亀岡市古世町西内坪101',
    tel: '0771-22-3113',
    googleMapUrl: 'https://maps.app.goo.gl/SzABXUbguh4E9CcQ8',
    lat: 35.01510667531934,
    lng: 135.5839547234174
  },
  {
    locationName: 'イオン伏見桃山',
    postalCode: '612-8054',
    address: '京都府京都市伏見区御堂前町６１６',
    tel: '0706-449-0452',
    googleMapUrl: 'https://maps.app.goo.gl/NW2Aykja3sBgkGkd6',
    lat: 34.93236189999999,
    lng: 135.76259772883594
  },
  {
    locationName: 'イオン高の原店',
    postalCode: '619-0223',
    address: '京都府木津川市相楽台１－１－１',
    tel: '0774-75-1566',
    googleMapUrl: 'https://maps.app.goo.gl/XWahq5dhdePYqtwv9',
    lat: 34.7253478322142,
    lng: 135.79053832491843
  },
  {
    locationName: 'イオン京都西店',
    postalCode: '615-0072',
    address: '京都府京都市右京区山ノ内池尻町１－１',
    tel: '0753-11-3364',
    googleMapUrl: 'https://maps.app.goo.gl/F4VQpWGVVSjeYJeX8',
    lat: 35.004544080843864,
    lng: 135.72096596730663
  },
  {
    locationName: 'イオン久御山店',
    postalCode: '613-0024',
    address: '京都府久世郡久御山町森南大内１５６－１',
    tel: '0756-33-1613',
    googleMapUrl: 'https://maps.app.goo.gl/MoMXf436JYDp1f3a7',
    lat: 34.89311320671642,
    lng: 135.7464690572288
  },
  {
    locationName: 'イオン福知山店',
    postalCode: '620-0922',
    address: '京都府福知山市岩井７９－８',
    tel: '0773-25-3660',
    googleMapUrl: 'https://maps.app.goo.gl/pe1XZfeWFeWdt21c7',
    lat: 35.316931700000005,
    lng: 135.1009382918001
  },
  {
    locationName: 'イオンスタイル西ノ京小町',
    postalCode: '602-8446',
    address: '京都府京都市中京区西ノ京冷泉町１',
    tel: '075-813-8001',
    googleMapUrl: 'https://maps.app.goo.gl/DcDEmMhHDZSJA1C99',
    lat: 35.01599599381064,
    lng: 135.7348441664055
  },
  {
    locationName: 'イオン近江八幡',
    postalCode: '523-0898',
    address: '滋賀県近江八幡市鷹飼町南3-7',
    tel: '0748-38-0330',
    googleMapUrl: 'https://maps.app.goo.gl/B3EXJdGSb2qG2Jmz5',
    lat: 35.12165165598975,
    lng: 136.1030762867733
  },
  {
    locationName: 'イオンスタイル草津',
    postalCode: '525-0067',
    address: '滋賀県草津市新居浜町300',
    tel: '077-599-600',
    googleMapUrl: 'https://maps.app.goo.gl/9YWBq75u346u8Xw88',
    lat: 34.998103057318495,
    lng: 135.9112012125293
  },
  {
    locationName: 'イオン長浜',
    postalCode: '526-0847',
    address: '滋賀県長浜市山階町271-1',
    tel: '0749-68-5500',
    googleMapUrl: 'https://maps.app.goo.gl/1xDEMbH1MrMu6dty9',
    lat: 35.396986157039684,
    lng: 136.28953128571558
  },
  {
    locationName: 'イオンいかるが',
    postalCode: '636-0154',
    address: '奈良県生駒郡斑鳩町龍田西8-1-15',
    tel: '0745-70-1100',
    googleMapUrl: 'https://maps.app.goo.gl/bapqRFmBLPYkoviw7',
    lat: 34.60463792321472,
    lng: 135.7132135153439
  },
  {
    locationName: 'イオン五條店',
    postalCode: '637-0004',
    address: '奈良県五條市今井2-150',
    tel: '0747-22-0271',
    googleMapUrl: 'https://maps.app.goo.gl/P5mEt8dNV9HXfp8x6',
    lat: 34.352920206797826,
    lng: 135.701779856456
  },
  {
    locationName: '大和郡山店',
    postalCode: '639-1101',
    address: '奈良県大和郡山市下三橋町741',
    tel: '0743-54-7111',
    googleMapUrl: 'https://maps.app.goo.gl/YtH46JxoHJZXJWP79',
    lat: 34.652235819903,
    lng: 135.80191400372036
  },
  {
    locationName: 'イオン登美ヶ丘店',
    postalCode: '639-0115',
    address: '奈良県生駒市鹿畑町3027',
    tel: '0743-70-0001',
    googleMapUrl: 'https://maps.app.goo.gl/HYB4t6YUCHNr2bUV6',
    lat: 34.72583862059915,
    lng: 135.7504710218904
  },
  {
    locationName: 'イオンスタイル奈良',
    postalCode: '631-0821',
    address: '奈良県奈良市西大寺東町2-4-1',
    tel: '0742-33-7001',
    googleMapUrl: 'https://maps.app.goo.gl/7fDhLSmStRmfRTHL8',
    lat: 34.695096098268074,
    lng: 135.7850681213442
  },
  {
    locationName: 'イオン桜井店',
    postalCode: '633-0061',
    address: '奈良県桜井市上之庄278-1',
    tel: '0744-44-1000',
    googleMapUrl: 'https://maps.app.goo.gl/R88j2YvGP6ugFv3PA',
    lat: 34.52178889999999,
    lng: 135.83674605767197
  },
  {
    locationName: 'イオンスタイル橿原',
    postalCode: '634-0837',
    address: '奈良県橿原市曲川町7-20-1',
    tel: '0744-25-8700',
    googleMapUrl: 'https://maps.app.goo.gl/LhS6tmV4fy6LZG8eA',
    lat: 34.506176100519355,
    lng: 135.76376863693804
  },
  {
    locationName: 'イオン八尾御坊前店',
    postalCode: '581-0003',
    address: '大阪府八尾市本町4-2-4',
    tel: '072-994-7951',
    googleMapUrl: 'https://maps.app.goo.gl/T9dUgjmtJ4yKPTWH8',
    lat: 34.6288816,
    lng: 135.5968459
  },
  {
    locationName: 'イオン布施駅前店',
    postalCode: '577-0056',
    address: '大阪府東大阪市長堂1-8-37',
    tel: '06-6785-6555',
    googleMapUrl: 'https://maps.app.goo.gl/LtMy7nFcDR8ihJcUA',
    lat: 34.66571408591765,
    lng: 135.563477454421
  },
  {
    locationName: 'イオンスタイル茨木',
    postalCode: '567-0033',
    address: '大阪府茨木市松ヶ本町8-30-3',
    tel: '072-645-3333',
    googleMapUrl: 'https://maps.app.goo.gl/KGAPwgmJEHhvrDg47',
    lat: 34.81089517051468,
    lng: 135.55840322275884
  },
  {
    locationName: 'イオン北千里店',
    postalCode: '565-0874',
    address: '大阪府吹田市古江台4-2-50',
    tel: '06-6835-5600',
    googleMapUrl: 'https://maps.app.goo.gl/NXQu59ofngaqGPJp6',
    lat: 34.81976430004211,
    lng: 135.50943414114823
  },
  {
    locationName: 'イオンスタイル箕面',
    postalCode: '562-0034',
    address: '大阪府箕面市西宿1-15-30',
    tel: '072-726-0888',
    googleMapUrl: 'https://maps.app.goo.gl/QUpcwmcx3u4mYcTM7',
    lat: 34.833014721346196,
    lng: 135.48940476741203
  },
  {
    locationName: 'イオン高槻',
    postalCode: '569-8567',
    address: '大阪府高槻市萩之庄3-47-2',
    tel: '072-669-5551',
    googleMapUrl: 'https://maps.app.goo.gl/uZ7opoJttkeayGZE9',
    lat: 34.85897809266683,
    lng: 135.64448571534393
  },
  {
    locationName: 'イオンスタイル新茨木',
    postalCode: '567-0824',
    address: '大阪府茨木市中津町18-1',
    tel: '072-632-5511',
    googleMapUrl: 'https://maps.app.goo.gl/cTcGLLZpFhWZpS8X6',
    lat: 34.81537490000001,
    lng: 135.58021985767198
  },
  {
    locationName: 'イオンスタイル四条畷',
    postalCode: '575-0001',
    address: '大阪府四條畷市砂四丁目3番2号',
    tel: '072-803-0200',
    googleMapUrl: 'https://maps.app.goo.gl/M1pQZd6ebm3pwX8x6',
    lat: 34.74703236280587,
    lng: 135.63059866063944
  },
  {
    locationName: 'イオンスタイル大日',
    postalCode: '570-0016',
    address: '大阪府守口市大日東町1-18',
    tel: '06-4252-3900',
    googleMapUrl: 'https://maps.app.goo.gl/ByXc1neBWnHjdTtu7',
    lat: 34.74957833072215,
    lng: 135.58019647116402
  },
  {
    locationName: 'イオン枚方店',
    postalCode: '573-0031',
    address: '大阪府枚方市岡本町7-1-203',
    tel: '072-843-0048',
    googleMapUrl: 'https://maps.app.goo.gl/nXSjrCgU4NpjSG5JA',
    lat: 34.815683199999995,
    lng: 135.6465551
  },
  {
    locationName: 'イオン鴻池店',
    postalCode: '578-0972',
    address: '大阪府東大阪市鴻池町1-1-72',
    tel: '06-6746-2221',
    googleMapUrl: 'https://maps.app.goo.gl/mvcwLnYiZmmAANEG6',
    lat: 34.69857399999999,
    lng: 135.6033972829867
  },
  {
    locationName: 'イオンスタイル野田阪神',
    postalCode: '553-0001',
    address: '大阪府大阪市福島区海老江1-1-23',
    tel: '06-6457-6300',
    googleMapUrl: 'https://maps.app.goo.gl/wMFhh19KFhsFGvTNA',
    lat: 34.695384587412086,
    lng: 135.47599385237163
  },
  {
    locationName: 'イオン鶴見緑地店',
    postalCode: '538-0053',
    address: '大阪市鶴見区鶴見4-17-1',
    tel: '06-4257-3322',
    googleMapUrl: 'https://maps.app.goo.gl/Z3YjiEsidnK38rv9A',
    lat: 34.70486711273513,
    lng: 135.56705388125636
  },
  {
    locationName: 'イオン高見店',
    postalCode: '554-0001',
    address: '大阪府大阪市此花区高見1-5',
    tel: '06-6462-330',
    googleMapUrl: 'https://maps.app.goo.gl/msq2d2Hu1Bo97wnx5',
    lat: 34.69152036339284,
    lng: 135.4595890021106
  },
  {
    locationName: 'イオン大阪ドームシティ',
    postalCode: '550-0023',
    address: '大阪府大阪市西区千代崎3-13-1',
    tel: '06-6584-1500',
    googleMapUrl: 'https://maps.app.goo.gl/ZuhbCJvtehF7xBmY6',
    lat: 34.67027259187251,
    lng: 135.47791902785562
  },
  {
    locationName: 'イオンスタイル海老江',
    postalCode: '553-0001',
    address: '大阪府大阪市福島区海老江1-5-20',
    tel: '06-4797-6222',
    googleMapUrl: 'https://maps.app.goo.gl/nb8v2edPMpf2uRs97',
    lat: 34.69801252439063,
    lng: 135.47625202664486
  },
  {
    locationName: 'イオン吹田店',
    postalCode: '564-0027',
    address: '大阪府吹田市朝日町2-101',
    tel: '06-6319-1147',
    googleMapUrl: 'https://maps.app.goo.gl/zM7D3qmjbigcpRoW6',
    lat: 34.76304352641314,
    lng: 135.52541980897598
  },
  {
    locationName: 'イオン古川橋',
    postalCode: '571-0030',
    address: '大阪府門真市末広町41-2',
    tel: '06-6906-7311',
    googleMapUrl: 'https://maps.app.goo.gl/a3y4fNhdyiAQ1azS7',
    lat: 34.7385744130801,
    lng: 135.59160769125455
  },
  {
    locationName: 'イオンスタイル東淀川',
    postalCode: '533-0014',
    address: '大阪府大阪市東淀川区豊新2-12-3',
    tel: '06-6160-8777',
    googleMapUrl: 'https://maps.app.goo.gl/ZHz2EpdRrbL7AV7k7',
    lat: 34.74190157222989,
    lng: 135.5269347721047
  },
  {
    locationName: 'イオン貝塚店',
    postalCode: '597-0053',
    address: '大阪府貝塚市地藏堂74-2',
    tel: '072-430-1501',
    googleMapUrl: 'https://maps.app.goo.gl/GX73ZjogNE3ihVMV6',
    lat: 34.4262682794619,
    lng: 135.3553538083783
  },
  {
    locationName: 'イオン和泉府中',
    postalCode: '594-0076',
    address: '大阪府和泉市肥子町2-2-1',
    tel: '0725-41-1430',
    googleMapUrl: 'https://maps.app.goo.gl/4bRxy32jkgMwnr5Z7',
    lat: 34.485879951651,
    lng: 135.42069507882115
  },
  {
    locationName: 'イオンりんくう泉南店',
    postalCode: '590-0535',
    address: '大阪府泉南市りんくう南浜3-12',
    tel: '072-480-6300',
    googleMapUrl: 'https://maps.app.goo.gl/eqoAiYiYD2xMS6GT7',
    lat: 34.38180274965786,
    lng: 135.2690399489432
  },
  {
    locationName: 'イオンスタイル金剛東',
    postalCode: '584-0082',
    address: '大阪府富田林市向陽台3-1-1',
    tel: '0721-28-1110',
    googleMapUrl: 'https://maps.app.goo.gl/1S5Dkc8jAipVh4D8A',
    lat: 34.50140486706989,
    lng: 135.57990329999998
  },
  {
    locationName: 'イオン日根野店',
    postalCode: '598-0021',
    address: '大阪府泉佐野市日根野2496-1',
    tel: '072-468-1300',
    googleMapUrl: 'https://maps.app.goo.gl/1JfpJeo8PjRmgkj59',
    lat: 34.39296347951285,
    lng: 135.33337369428318
  },
  {
    locationName: 'イオン堺北花田',
    postalCode: '591-8008',
    address: '大阪府堺市北区東浅香山町4-1-12',
    tel: '072-257-6100',
    googleMapUrl: 'https://maps.app.goo.gl/iPzjn74SS55NVU3g6',
    lat: 34.58464460128804,
    lng: 135.51512961031042
  },
  {
    locationName: 'イオン喜連瓜破駅前',
    postalCode: '547-0024',
    address: '大阪府大阪市平野区瓜破2-1-13',
    tel: '06-6760-1777',
    googleMapUrl: 'https://maps.app.goo.gl/nx7YGruX8vmFBaRR9',
    lat: 34.60829240000002,
    lng: 135.551900757672
  },
  {
    locationName: 'イオンスタイル堺鉄炮町',
    postalCode: '590-0905',
    address: '大阪府堺市堺区鉄砲町1-1',
    tel: '072-221-0006',
    googleMapUrl: 'https://maps.app.goo.gl/sKrkx8pfvJYXQEp28',
    lat: 34.59413265674776,
    lng: 135.47987263911648
  },
  {
    locationName: 'イオンスタイル和歌山',
    postalCode: '640-8451',
    address: '和歌山県和歌山市中字楠谷573番地',
    tel: '073-456-2700',
    googleMapUrl: 'https://maps.app.goo.gl/HGsrJgtPJgfZvcLG8',
    lat: 34.27461941909881,
    lng: 135.14924437368282
  },
  {
    locationName: 'イオンスタイル新金岡',
    postalCode: '591-8021',
    address: '大阪府堺市北区新金岡町4-1-11 ',
    tel: '072-240-2058',
    googleMapUrl: 'https://maps.app.goo.gl/ZJ2QfhDG2sLAFLyW7',
    lat: 34.56669283934776,
    lng: 135.51535619999999
  },
  {
    locationName: 'イオンスタイル東岸和田',
    postalCode: '596-0825',
    address: '大阪府岸和田市土生町2－32－39',
    tel: '072-430-5810',
    googleMapUrl: 'https://maps.app.goo.gl/tAHPMadtXAg6ZvPY8',
    lat: 34.447777147450246,
    lng: 135.38194652883598
  },
  {
    locationName: 'イオンスタイル金剛',
    postalCode: '589-0011',
    address: '⼤阪府⼤阪狭⼭市半⽥1丁⽬22',
    tel: '072-360-1150',
    googleMapUrl: 'https://maps.app.goo.gl/vbMv3YDabsKWHfcf9',
    lat: 34.49725725723116,
    lng: 135.55766379777566
  },
  {
    locationName: 'イオン神戸北店',
    postalCode: '651-1515',
    address: '兵庫県神戸市北区上津台8-1-1',
    tel: '078-983-3500',
    googleMapUrl: 'https://maps.app.goo.gl/Cz8oc2dFjqAXqRez5',
    lat: 34.86001651984954,
    lng: 135.1943236457683
  },
  {
    locationName: 'イオンつくしが丘店',
    postalCode: '651-1212',
    address: '兵庫県神戸市北区筑紫が丘3-2-10',
    tel: '078-583-2570',
    googleMapUrl: 'https://maps.app.goo.gl/MtsnF24JzwqQCj4J8',
    lat: 34.746236447154644,
    lng: 135.16401965767196
  },
  {
    locationName: 'イオンスタイル神戸南',
    postalCode: '652-0844',
    address: '兵庫県神戸市兵庫区中之島２-1-1',
    tel: '078-686-0818',
    googleMapUrl: 'https://maps.app.goo.gl/jC63fA38qVoXfNB98',
    lat: 34.66623069999999,
    lng: 135.17501049999996
  },
  {
    locationName: 'イオンスタイルumie',
    postalCode: '650-0044',
    address: '兵庫県神戸市中央区東川崎町1-7-5神戸ハーバーランドumieノースモール1F',
    tel: '078-360-3700',
    googleMapUrl: 'https://maps.app.goo.gl/Go1UXLmBWA5uu5YKA',
    lat: 34.680070913873564,
    lng: 135.1825046
  },
  {
    locationName: 'イオンジェームス山店',
    postalCode: '655-0873',
    address: '兵庫県神戸市垂水区青山台7-7-1',
    tel: '078-753-8666',
    googleMapUrl: 'https://maps.app.goo.gl/PTiiwE7VehFvAB6s8',
    lat: 34.646148147231585,
    lng: 135.076291457672
  },
  {
    locationName: 'イオン垂水店',
    postalCode: '655-0029',
    address: '兵庫県神戸市垂水区兵庫県天ノ下町1-1',
    tel: '078-704-3800',
    googleMapUrl: 'https://maps.app.goo.gl/E4NMgkVW86ZrPExq5',
    lat: 34.630158900000005,
    lng: 135.05205892883598
  },
  {
    locationName: 'イオン猪名川店',
    postalCode: '666-0257',
    address: '兵庫県川辺郡猪名川町白金2-1',
    tel: '072-765-1111',
    googleMapUrl: 'https://maps.app.goo.gl/ukohgtMU91wUporh7',
    lat: 34.90163300180209,
    lng: 135.36442265767198
  },
  {
    locationName: 'イオンスタイル伊丹昆陽',
    postalCode: '664-0027',
    address: '兵庫県伊丹市池尻4-1-1',
    tel: '072-773-6900',
    googleMapUrl: 'https://maps.app.goo.gl/TqQWCcmbynCxyDkA9',
    lat: 34.784338837853724,
    lng: 135.38305764304158
  },
  {
    locationName: 'イオンスタイル伊丹',
    postalCode: '664-0847',
    address: '兵庫県伊丹市藤ノ木1-1-1',
    tel: '072-787-0500',
    googleMapUrl: 'https://maps.app.goo.gl/okzmVi5Vfo45D8hg9',
    lat: 34.782572535515556,
    lng: 135.42300472883596
  },
  {
    locationName: 'イオンスタイル尼崎',
    postalCode: '661-0965',
    address: '兵庫県尼崎市次屋3-13-18',
    tel: '06-4960-5010',
    googleMapUrl: 'https://maps.app.goo.gl/9mB73fdsEZSsJnSg6',
    lat: 34.741837816186674,
    lng: 135.44233712883596
  },
  {
    locationName: 'イオン三田ウッディタウン店',
    postalCode: '669-1321',
    address: '兵庫県三田市けやき台1-6-2',
    tel: '079-564-8800',
    googleMapUrl: 'https://maps.app.goo.gl/p7TPMXj3BtjoPrdM7',
    lat: 34.90831077254129,
    lng: 135.1865924909416
  },
  {
    locationName: 'イオンスタイル洲本',
    postalCode: '656-0021',
    address: '兵庫県洲本市塩屋1-1-8',
    tel: '0799-23-2150',
    googleMapUrl: 'https://maps.app.goo.gl/YHqpzbnHrRVeq4JW7',
    lat: 34.344917266685464,
    lng: 134.892928957672
  },
  {
    locationName: 'イオン南淡路店',
    postalCode: '656-0511',
    address: '兵庫県南あわじ市賀集八幡北378-1',
    tel: '0799-50-2050',
    googleMapUrl: 'https://maps.app.goo.gl/By24WX9QceP2NsJp6',
    lat: 34.27956956522877,
    lng: 134.74084159999995
  },
  {
    locationName: 'イオン淡路店',
    postalCode: '656-2132',
    address: '兵庫県淡路市志筑新島10-2',
    tel: '0799-62-6300',
    googleMapUrl: 'https://maps.app.goo.gl/pGBMUaBFjxLXZ4Zr6',
    lat: 34.425969850241515,
    lng: 134.90597680000005
  },
  {
    locationName: 'イオンリカー＆ビューティー川西店',
    postalCode: '666-0015',
    address: '兵庫県川西市小花1-6-13',
    tel: '072-755-2588',
    googleMapUrl: 'https://maps.app.goo.gl/nXWPQ69cjfmLA2G17',
    lat: 34.82702172126324,
    lng: 135.41413022883597
  },
  {
    locationName: 'イオン西宮',
    postalCode: '663-8014',
    address: '兵庫県西宮市林田町2-24',
    tel: '0798-64-2501',
    googleMapUrl: 'https://maps.app.goo.gl/JQp9tNaEKUcckQ1f9',
    lat: 34.75599528532531,
    lng: 135.36216357116402
  },
  {
    locationName: 'イオン三田店',
    postalCode: '669-1546',
    address: '兵庫県三田市弥生ケ丘1-1-1',
    tel: '079-562-4711',
    googleMapUrl: 'https://maps.app.goo.gl/5ZJESPoYnUn9GngV7',
    lat: 34.8847131009128,
    lng: 135.20166799999998
  },
  {
    locationName: 'イオンスタイル甲子園',
    postalCode: '663-8166',
    address: '兵庫県西宮市甲子園高潮町3-3',
    tel: '0798-45-0077',
    googleMapUrl: 'https://maps.app.goo.gl/KNar5hatjgz7wD9W6',
    lat: 34.72370046375938,
    lng: 135.36184272883597
  },
  {
    locationName: 'イオン藤原台店',
    postalCode: '651-1302',
    address: '兵庫県神戸市北区藤原台中町1-2-2',
    tel: '078-982-4711',
    googleMapUrl: 'https://maps.app.goo.gl/FtpWejaGQozkL1WM8',
    lat: 34.821913592367906,
    lng: 135.2202977
  },
  {
    locationName: 'イオン三木青山店',
    postalCode: '673-0521',
    address: '兵庫県三木市志染町青山3-9',
    tel: '0794-87-2031',
    googleMapUrl: 'https://maps.app.goo.gl/unw1WUvqrXorfnAD6',
    lat: 34.779529187838286,
    lng: 135.03645192883596
  },
  {
    locationName: 'イオン明石',
    postalCode: '674-0068',
    address: '兵庫県明石市大久保町ゆりのき通り3-3-1',
    tel: '078-934-2881',
    googleMapUrl: 'https://maps.app.goo.gl/AMUjD5jqmntJ1f7N9',
    lat: 34.678666437548934,
    lng: 134.93523239365197
  },
  {
    locationName: 'イオン加古川',
    postalCode: '675-0101',
    address: '兵庫県加古川市平岡町新在家615-1',
    tel: '079-425-4121',
    googleMapUrl: 'https://maps.app.goo.gl/wUDGGmqzFoz5Lph57',
    lat: 34.74959459681363,
    lng: 134.86288623098943
  },
  {
    locationName: 'イオン姫路',
    postalCode: '670-0807',
    address: '兵庫県姫路市増位本町2-12-10',
    tel: '079-224-2121',
    googleMapUrl: 'https://maps.app.goo.gl/cj9UGHjT3ELJkQ3N7',
    lat: 34.856601811265904,
    lng: 134.70634107331006
  },
  {
    locationName: 'イオン小野',
    postalCode: '675-1378',
    address: '兵庫県小野市王子町868-1',
    tel: '0794-63-5121',
    googleMapUrl: 'https://maps.app.goo.gl/voV4majbevmXFhNM9',
    lat: 34.856471292130244,
    lng: 134.93570722883598
  },
  {
    locationName: 'イオン和田山',
    postalCode: '669-5215',
    address: '兵庫県朝来市和田山町枚田岡774',
    tel: '079-670-2600',
    googleMapUrl: 'https://maps.app.goo.gl/zceJ4TrzpWptgNuk6',
    lat: 35.329485453015074,
    lng: 134.86371192883595
  },
  {
    locationName: 'イオン赤穂',
    postalCode: '678-0232',
    address: '兵庫県赤穂市中広字別所55-3',
    tel: '0791-43-6911',
    googleMapUrl: 'https://maps.app.goo.gl/ximaQdRHBGMHyqtE7',
    lat: 34.755631,
    lng: 134.4007298
  },
  {
    locationName: 'イオン土山',
    postalCode: '674-0074',
    address: '兵庫県明石市魚住町清水字舞々2208-1',
    tel: '078-942-0811',
    googleMapUrl: 'https://maps.app.goo.gl/2AJy32U8Muc5489C7',
    lat: 34.72125663214993,
    lng: 134.89257583179713
  },
  {
    locationName: 'イオン山崎',
    postalCode: '671-2545',
    address: '兵庫県宍粟郡宍粟市山崎町中井字城下10',
    tel: '0790-63-0505',
    googleMapUrl: 'https://maps.app.goo.gl/knmk6wNP6vSPxerc9',
    lat: 35.00218391168721,
    lng: 134.54351080000004
  },
  {
    locationName: 'イオン三木',
    postalCode: '673-0404',
    address: '兵庫県三木市大村字砂163',
    tel: '0794-83-3155',
    googleMapUrl: 'https://maps.app.goo.gl/HwBVUoGMpsfFzsvs7',
    lat: 34.80531911171127,
    lng: 134.97216576513932
  },
  {
    locationName: 'イオン姫路リバーシティ',
    postalCode: '672-8064',
    address: '兵庫県姫路市飾磨区細江2560',
    tel: '079-231-2210',
    googleMapUrl: 'https://maps.app.goo.gl/D6oVU4GVJePWk2fA9',
    lat: 34.798520689867324,
    lng: 134.668264157672
  },
  {
    locationName: 'イオン社店',
    postalCode: '673-1431',
    address: '兵庫県加東市社1126-1',
    tel: '0795-40-2300',
    googleMapUrl: 'https://maps.app.goo.gl/KC2us3S98ARLTNbu8',
    lat: 34.91420621273591,
    lng: 134.96255832187845
  },
  {
    locationName: 'イオン高砂',
    postalCode: '676-0019',
    address: '兵庫県高砂市緑丘2-1-40',
    tel: '079-444-2700',
    googleMapUrl: 'https://maps.app.goo.gl/p2SJFyqZ77eM4w9UA',
    lat: 34.76923288673866,
    lng: 134.8027223
  },
  {
    locationName: 'イオン姫路大津',
    postalCode: '671-1146',
    address: '兵庫県姫路市大津区大津町2-5',
    tel: '079-230-6810',
    googleMapUrl: 'https://maps.app.goo.gl/4A1RcweBQ2w8tDgp6',
    lat: 34.806541825942375,
    lng: 134.60669008409698
  },
  {
    locationName: 'イオン加西北条',
    postalCode: '675-2312',
    address: '兵庫県加西市北条町北条308-1',
    tel: '0790-45-3500',
    googleMapUrl: 'https://maps.app.goo.gl/9AVTohx5ib36QceZ6',
    lat: 34.92986753007956,
    lng: 134.82928361640347
  },
];
